export default (id, path) =>
	new Promise((resolve) => {
		if (document && document.querySelectorAll(`#${id}`).length === 0) {
			const script = document.createElement('script');
			script.id = id;
			script.src = path;
			script.onload = () => resolve();
			document.head.appendChild(script);
		} else {
			resolve();
		}
	});
